import { secureFetch } from "./authService";
import { API_BASE_URL } from "./constants";

export function getRoles() {
	return secureFetch(API_BASE_URL + '/users/roles', {
		method: 'GET'
	});
}



// WEBPACK FOOTER //
// ./src/helpers/roleService.js